import {observable, computed, action, autorun} from 'mobx';
import File from './FileStore';

export default class ImposerStore {
  @observable files = [];

  constructor() {

  }

  @action addFiles(files) {
    console.log("incoming files", files.length, files);
    for (let i = 0; i < files.length; i++) {
      this.files.push(new File(files[i]));
    }
  }

  @action removeFile(index) {
    this.files.splice(index, 1);
  }

}



// WEBPACK FOOTER //
// ./src/views/Imposer/ImposerStore.js